import { type AxiosError } from 'axios'
import { proxySignIn, resetProxySignIn } from '../../../../routes/auth/login/proxySignIn'
import { buildAxiosInstance } from '../../../utils/apiUtils'
import { proxyGlobalAuth } from '../../../proxies/proxyGlobalAuth'

interface Args {
  ppMerchantId: string
}

interface ResponseData {
  authToken: string
  passwordResetDate: string | null
}

interface Response {
  data: ResponseData | null
  error: string | null
}

export async function executeUserHotSwap ({ ppMerchantId }: Args): Promise<void> {
  proxySignIn.apiCallSignIn.error = null
  try {
    const response = await buildAxiosInstance().post<Response>('/api/auth/hot_swap', {
      ppMerchantId
    })
    if (response.data.data) {
      proxyGlobalAuth.authToken = response.data.data?.authToken
      resetProxySignIn()
    } else {
      proxySignIn.apiCallSignIn.error = 'Unknown Error'
    }
  } catch (e) {
    if (e instanceof Error) {
      const bodyError = (e as AxiosError<Response>).response?.data?.error
      proxySignIn.apiCallSignIn.error = bodyError ?? e.message
    }
  } finally {
    location.replace('/app')
  }
}
